import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Aviation/Texan phrase pool. Inline so future edits land in one place
 * without touching the render code.
 */
export const LOADING_PHRASES = [
  "Loadin' up the fuel tanks…",
  "Gettin' your template ready…",
  "Wranglin' your template…",
  "Saddlin' up your site…",
  "Firin' up the engines…",
  "Fixin' to get airborne…",
  "Spoolin' up the turbines…",
  "Dustin' off your template…",
  "Gettin' clearance from the tower…",
  "Greasin' the landing gear…",
  "Roundin' up your bits and bytes…",
  "Y'all hold tight, prepin' for liftoff…",
  "Polishin' the cockpit glass…",
  "Wakin' up the autopilot…",
  "Markin' the runway lights…",
] as const;

const pickPhrase = (): string =>
  LOADING_PHRASES[Math.floor(Math.random() * LOADING_PHRASES.length)];

/**
 * Zero-state-style loading block. Mirrors `<EmptyState>`'s visual rhythm
 * (centred stack, large title, generous padding) minus the description
 * and action button — the spinner does the motion, the phrase carries it.
 *
 * The phrase is picked once at mount and frozen for the duration. A fresh
 * mount picks a new phrase. Visibility should be gated by a parent using
 * `useDelayedLoader` so fast loads suppress the block entirely.
 */
export const LoadingState: React.FC = () => {
  const [phrase] = useState<string>(pickPhrase);
  return (
    <div className="flex flex-col items-center justify-center text-center gap-4 py-16 px-gutter">
      <Loader2 className="h-8 w-8 text-muted-foreground animate-spin" strokeWidth={1.5} />
      <h3 className="text-2xl font-medium text-foreground">{phrase}</h3>
    </div>
  );
};

export default LoadingState;
